import { render } from "./MediaPage.vue?vue&type=template&id=ee92fd2a"
import script from "./MediaPage.vue?vue&type=script&lang=js"
export * from "./MediaPage.vue?vue&type=script&lang=js"

import "./MediaPage.vue?vue&type=style&index=0&id=ee92fd2a&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__